<template lang="pug">
    div.footerMenu
        v-progress-linear(v-if="pages.length==0" :indeterminate="true")
        div.menuItem(v-for="item in pages" :key="item.id")
            router-link( :to="'/page/'+item.alias") {{ $showLocalizedField(item.name, locale).text }}
            
        div.menuItem
            router-link(:to="'/dictresult'") {{ 'DICT_RESULT' | localize }}
</template>

<script>
    import { mapState } from "vuex";
    export default {
        mounted () {
            
        },

        computed: {
            ...mapState(['locale']),
            ...mapState('pages',['pages']),
        },

        methods: {
            gotoPage(alias){
                let path = '/page/'+alias
                this.$router.push(path)
            }
        },

        data() {
            return {
                
            }
        }
    }
</script>

<style lang="scss" scoped>
    .footerMenu {
        width: 167px;
    }
    .menuItem {
        font-size: 18px;
    }
    .menuItem a {
        color: #757575;
        text-decoration: none;
    }
    .menuItem a.routeactive {
        color:#ED0E51;
    }
</style>